export const Input = {
    baseStyle: {
        field: {},
    },
    variants: {
        simple: {
            field: {
                bg: "#FFFFFF",
                border: "1px solid",
                borderRadius: "10px",
                borderColor: "neutral.600",
                _disabled: {
                    bg: "#ECECED",
                    cursor: "not-allowed",
                },
                _invalid: {
                    borderColor: "error",
                },
                _focus: {
                    bg: "primary.100",
                    borderColor: "#FFFFFF",
                },
                minH: "fit-content",
                height: "auto",
                p: "2",
            },
        },
    },
    defaultProps: {
        variant: "simple",
    },
};
